import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Sidebar, SidebarBody, SidebarFooter, SidebarHeader, SidebarMenuItem, makeStyles, useObservable } from '@cicero/ui'

import { EditorModal } from 'editor'
import { PageSchema, useModel } from 'models'
import { PageFilterOptionsContext } from 'models/filters'
import { usePageFilterOptions } from 'models/hooks'

// import { TimerCounter } from './user/TimerCounter'
import { UserContextMenu } from './user/UserContextMenu'
import { LoginForm } from './user/LoginForm'
import { OfflineSyncState } from './user/OfflineSyncState'
import { SearchPage } from './pages/SearchPage'
import { InboxPage } from './pages/InboxPage'
import { EditorPage } from './pages/EditorPage'
import { ProfilePage } from './pages/ProfilePage'
import { SettingsPage } from './pages/SettingsPage'

export const App = () => {
  const { appWrapper, pageWrapper } = styles()
  const Pages = useModel(PageSchema)
  const pages = useObservable(() => Pages.QUERY$(PageSchema.QUERIES.parentless), [], [])
  const filterOptions = usePageFilterOptions()
  const activePage = useObservable(() => Pages.active$, null, [])

  return (
    <BrowserRouter>
      <PageFilterOptionsContext.Provider value={filterOptions}>
        <div className={appWrapper}>
          <Sidebar>
            <SidebarHeader>
              <SidebarMenuItem to="/" name="CC" noActive />
              <SidebarMenuItem to="/search" name="Search" icon="search" />
              <SidebarMenuItem to="/" name="Inbox" icon="email" />
            </SidebarHeader>
            <SidebarBody>
              { pages.map((fave, i) => <SidebarMenuItem
                icon={ fave.icon || PageSchema.DEFAULT_ICON }
                key={i}
                name={fave.title || ''}
                small
                to={PageSchema.getPageLink(fave)}
              />) }
            </SidebarBody>
            <SidebarFooter>
              {/* <TimerCounter /> */}
              <UserContextMenu />
            </SidebarFooter>
          </Sidebar>
          <div className={pageWrapper}>
            <Switch>
              <Route exact path="/create" component={EditorPage} />
              <Route exact path="/login" component={LoginForm} />
              <Route exact path="/search" component={SearchPage} />
              <Route path="/settings" component={SettingsPage} />

              <Route exact path="/:owner_id" component={ProfilePage} />
              <Route exact path="/:owner_id/:page_id" component={EditorPage} />
              <Route exact path="/" component={InboxPage} />
            </Switch>
          </div>
        </div>
        <OfflineSyncState />
        <EditorModal page={activePage} />
      </PageFilterOptionsContext.Provider>
    </BrowserRouter>
  )
}

const styles = makeStyles({
  appWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    height: '100vh',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  pageWrapper: {
    overflow: 'auto',
    flexGrow: 1,
    display: 'flex',
    background: '#f8f9fa',
  },
})
